'use es6';

import { Record } from 'immutable';
import PerRespondentTypeRecord from './PerRespondentTypeRecord';
const ThankYouRecord = Record({
  bodies: PerRespondentTypeRecord,
  headers: PerRespondentTypeRecord,
  images: PerRespondentTypeRecord,
  imageUrl: undefined,
  imageAlt: ''
});
export default ThankYouRecord;